import React from 'react';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import AuthProvider from "../../hooks/authProvider";
import {redirect} from "react-router-dom";
import PageTitle from "../../components/PageTitle";

export async function loader({request, params}) {
    if (!(await AuthProvider.checkAuth())) {
        const params = new URLSearchParams();
        params.set("from", new URL(request.url).pathname);
        return redirect("/login?" + params.toString());
    }
    return null;
}

export default function RedocViewer() {
    return (
        <div style={{width: "100%", height: "100vh"}}>
            <PageTitle title="API документація" />
            <SwaggerUI url="/api/documentation/schema/"/>
        </div>
    );
}
